
class LocalStorage {
    static getItem: any;

    /** SOMENTE PARA SUBMASTER */
    saveAuthToken(token: string) : void {
      localStorage.setItem('authToken', token);
    }
    removeAuthToken(): void {
      localStorage.removeItem('authToken');
    }
    getAuthToken(): string | null {
      return localStorage.getItem('authToken');
    }
   
    /** TUTORIAL STORAGE */
    savelocalStorage(step: string): void {
      localStorage.setItem("management_tutorial_step", step);
    }

    removeTutorial(): void {
      localStorage.removeItem("management_tutorial_step");
    }

    getStep(): string | null {
      return localStorage.getItem("management_tutorial_step");
    }


    /** SOMENTE PARA USUARIO DO SUBMASTER */
    saveAuthTokeUserToSubmaster(token: string) : void {
      localStorage.setItem('authTokenUser', token);
    }
    removeAuthTokenUserToSubmaster(): void {
      localStorage.removeItem('authTokenUser');
    }
    getAuthTokenUserToSubmaster(): string | null {
      return localStorage.getItem('authTokenUser');
    }
  }
  

  export default LocalStorage; // A classe é exportada corretamente
